export default "__VITE_ASSET__Dr0aL9W4__"